export const ICON_OUTPUT_SIZE = { width: 72, height: 72 } as const;
export const ICON_VIEWPORT = {
  width: 436,
  height: 224,
  type: "square" as const,
};
